import styled from "styled-components";

import { Pagination } from "antd";
export const PaginationStyled = styled(Pagination)``;

export const Item = styled.div`
  width: 38px;
  height: 38px;
  padding: 8px 10px;
  border: solid 1px #0d0d0d;
  color: #999999;
`;
